import { render, staticRenderFns } from "./_Modal.vue?vue&type=template&id=68b446b5&scoped=true&"
import script from "./_Modal.vue?vue&type=script&lang=js&"
export * from "./_Modal.vue?vue&type=script&lang=js&"
import style0 from "./_Modal.vue?vue&type=style&index=0&id=68b446b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b446b5",
  null
  
)

export default component.exports